export default __webpack_public_path__ + "static/media/Office_Filled_Active.1eb0e008.svg";